import double1 from "../../images/Rooms/DoubleTwin/dt1.jpg";
import double2 from "../../images/Rooms/DoubleTwin/dt2.jpg";
import double3 from "../../images/Rooms/DoubleTwin/dt3.jpg";
import double4 from "../../images/Rooms/DoubleTwin/dt4.jpg";
import double5 from "../../images/Rooms/DoubleTwin/dt5.jpg";

import triple1 from "../../images/Rooms/TripleQuadruple/t1.jpg";
import triple2 from "../../images/Rooms/TripleQuadruple/t2.jpg";

import family1 from "../../images/Rooms/FamilyRoom/fr1.jpg";
import family2 from "../../images/Rooms/FamilyRoom/fr2.jpg";
import family3 from "../../images/Rooms/FamilyRoom/fr3.jpg";
import family4 from "../../images/Rooms/FamilyRoom/fr4.jpg";
import family5 from "../../images/Rooms/FamilyRoom/fr5.jpg";
import family6 from "../../images/Rooms/FamilyRoom/fr6.jpg";

import apartments1 from "../../images/Rooms/Apartment/a3.jpg";
import apartments2 from "../../images/Rooms/Apartment/a4.jpg";
import apartments3 from "../../images/Rooms/Apartment/a5.jpg";
import apartments4 from "../../images/Rooms/Apartment/a6.png";
import apartments5 from "../../images/Rooms/Apartment/a7.jpg";
import apartments6 from "../../images/Rooms/Apartment/a9.jpg";
import apartments7 from "../../images/Rooms/Apartment/a10.jpg";
import apartments8 from "../../images/Rooms/Apartment/a11.jpg";
import apartments9 from "../../images/Rooms/Apartment/a12.jpg";
import apartments10 from "../../images/Rooms/Apartment/a13.jpg";
import apartments11 from "../../images/Rooms/Apartment/a14.jpg";
import apartments12 from "../../images/Rooms/Apartment/a15.jpg";
import apartments13 from "../../images/Rooms/Apartment/a16.jpg";
import apartments14 from "../../images/Rooms/Apartment/a17.jpg";
import apartments15 from "../../images/Rooms/Apartment/a18.jpg";
import apartments16 from "../../images/Rooms/Apartment/a19.jpg";
import apartments17 from "../../images/Rooms/Apartment/a20.jpg";
import apartments18 from "../../images/Rooms/Apartment/a21.jpg";
import apartments19 from "../../images/Rooms/Apartment/a22.jpg";


import blue_house4 from "../../images/Houses/BlueHouse/new/bh.jpg";
import blue_house8 from "../../images/Houses/BlueHouse/new/bh2.jpg";
import blue_house5 from "../../images/Houses/BlueHouse/new/bh4.jpg";
import blue_house2 from "../../images/Houses/BlueHouse/bh2.jpg";
import blue_house3 from "../../images/Houses/BlueHouse/bh4.jpg";
import blue_house from "../../images/Houses/BlueHouse/bh6.jpg";
import blue_house7 from "../../images/Houses/BlueHouse/bh7.jpg";

import green_house from "../../images/Houses/Greenhouse Outside.jpg";
import green_house2 from "../../images/view-gallery/houses/GreenHouse/gh1.jpg";
import green_house3 from "../../images/view-gallery/houses/GreenHouse/GH_kitchen.jpg";
import green_house4 from "../../images/view-gallery/houses/GreenHouse/GreenHouse1.jpg";
import green_house5 from "../../images/view-gallery/houses/GreenHouse/Livingroom2.png";
import green_house7 from "../../images/view-gallery/houses/GreenHouse/GH_bathroom.jpg";

import grotta_northern_lights from "../../images/Houses/GNL/gnl1.jpg";
import grotta_northern_lights3 from "../../images/Houses/GNL/gnl3.jpg";
import grotta_northern_lights4 from "../../images/Houses/GNL/gnl4.jpg";
import grotta_northern_lights5 from "../../images/Houses/GNL/gnl5.jpg";
import grotta_northern_lights6 from "../../images/Houses/GNL/gnl6.jpg";
import grotta_northern_lights7 from "../../images/Houses/GNL/gnl7.jpg";
import grotta_northern_lights8 from "../../images/Houses/GNL/gnl8.jpg";
import grotta_northern_lights10 from "../../images/Houses/GNL/gnl9.png";
import grotta_northern_lights9 from "../../images/Houses/GNL/gnl10.jpg";

import NorthernLights3 from "../../images/view-gallery/northern_lights3.jpg";
import NorthernLights2 from "../../images/view-gallery/northern_lights2.jpg";
import NorthernLights from "../../images/Surroundings/surrounding3.jpg";

import Neighborhood from "../../images/view-gallery/neighborhood.jpeg";
import Neighborhood2 from "../../images/view-gallery/neighborhood2.jpg";
import Neighborhood3 from "../../images/view-gallery/neighborhood3.jpg";

import Activities2 from "../../images/view-gallery/Activities/1.jpg";
import Activities3 from "../../images/view-gallery/Activities/2.jpg";
import Activities4 from "../../images/view-gallery/Activities/3.jpg";
import Activities from "../../images/view-gallery/Activities/4.jpg";

const RoomsData = [
  {
    title: "Double/Twin",
    backgrounds: [
      double1,
      double2,
      double3,
      double4,
      double5,
    ],
    description:
        "Our double/twin rooms are available at 3 of our properties. Facing the seaside, the rooms are equipped with a king-size or twin bed and Netflix TV. Some rooms offer shared bathroom and kitchen facilities.",
  },
  {
    title: "Triple/Quadruple",
    backgrounds: [
      triple1,
      triple2,
    ],
    description:
        "The Triple/Quadruple Rooms are located in two of the three buildings. They feature a sofa bed and flat screen TVs with Netflix. Twin beds can be requested depending on availability. Bathroom and kitchen facilities are shared.",
  },
  {
    title: "Family Room",
    backgrounds: [
      family1,
      family2,
      family3,
      family4,
      family5,
      family6,
    ],
    description:
        "The Family Room with a terrace overlooking the ocean and the lighthouse is located in the Grótta Northern Lights Apartment in Valhúsabraut 35. It includes a TV with Netflix, as well as a private bathroom and dining area. Kitchen facilities are shared.",
  },
  {
    title: "Two-bedroom Apartment",
    backgrounds: [
      apartments1,
      apartments2,
      apartments3,
      apartments4,
      apartments5,
      apartments6,
      apartments7,
      apartments8,
      apartments9,
      apartments10,
      apartments11,
      apartments12,
      apartments13,
      apartments14,
      apartments15,
      apartments16,
      apartments17,
      apartments18,
      apartments19,
    ],
    description:
        "Two-Bedroom Bungalow Apartment located in the garden of the Blue House, this apartment is equipped with a kitchenette, private bathroom, sofa bed, as well as two TVs with Netflix.",
  },
];

const HousesData = [
  {
    title: "Blue House",
    backgrounds: [
      blue_house4,
      blue_house8,
      blue_house5,
      blue_house2,
      blue_house3,
      blue_house,
      blue_house7,
    ],
    description:
        "Blue House is an authentic Icelandic-style home that offers a variety of rooms and a truly northern experience. Enjoy scenic views of the sea and mountains. This cosy, yet modern bed and breakfast, is situated on the small peninsula of Seltjarnarnes and 5 minute drive by car from the city of Reykjavik.",
  },
  {
    title: "Green House",
    backgrounds: [
      green_house,
      green_house2,
      green_house3,
      green_house4,
      green_house5,
      green_house7,
    ],
    description:
        "The two-bedroom apartment called Green House is located in the garden of the Blue House. It is perfect for solo travellers or small groups of friends looking for a peaceful getaway. It features a kitchenette, a living area and a bathroom with shower.",
  },
  {
    title: "Grótta Northern Lights",
    backgrounds: [
      grotta_northern_lights,
      grotta_northern_lights3,
      grotta_northern_lights4,
      grotta_northern_lights5,
      grotta_northern_lights6,
      grotta_northern_lights7,
      grotta_northern_lights8,
      grotta_northern_lights9,
      grotta_northern_lights10,
    ],
    description:
        "Grótta Northern Lights Apartment is a modern and cosy home that makes its guests feel like locals. Located 10 minutes from downtown Reykjavik on the peninsula of Seltjarnarnes, this peaceful three-room apartment offers a stunning view of the ocean.",
  },
];

const SurroundingsData = [
  {
    title: "Northern Lights",
    backgrounds: [NorthernLights, NorthernLights2, NorthernLights3],
    description:
        "Close to the Blue House, the best place to spot northern lights is by Grótta Lighthouse. Located on the edge of Seltjarnarnes Peninsula in a protected nature reserve home to more than 100 different bird species and 140 plant varieties, the lighthouse was built in 1897 and fully restored in 1947. You can easily reach it with a pleasant 25-minutes walk from the Blue House.",
  },
  {
    title: "Neighbourhood",
    backgrounds: [Neighborhood, Neighborhood2, Neighborhood3],
    description:
        "Seltjarnarnes is a very quiet town: you will definitely have a very relaxing stay with us! You will often see kids playing or running in the streets, parents walking with their toddlers, and cute, furry cats strolling around undisturbed. Did you know that in 2007 Seltjarnarnes became the world's first town where every citizen had access to fiber optics?",
  },
  {
    title: "Activities",
    backgrounds: [ Activities, Activities2, Activities3, Activities4],
    description:
        "While visiting Seltjarnarnes Peninsula, stroll through Valhúsahæð Park, behind the Blue House, then head to the Grótta Lighthouse, located in a protected nature reserve. Don’t miss the Kvika Foot Bath, a geothermal small pool that allows you to enjoy the beautiful view of Esja Mountain and Snæfellsjökull Glacier.",
  },
];

const customModalData = [RoomsData, HousesData, SurroundingsData];

export default customModalData;
